/**
 * PickupDateAlert — 酒店预订日期选择弹窗组件（单例模式）
 * 参照：diandatravel.com 产品页中 tpb-widget-popup 交互模式
 */

;(function () {
  'use strict'

  // 单例守卫：snippet 会在房型循环里被渲染几十次，每个 <script src> 标签
  // 浏览器都会各自执行一遍（同名 src 不会跨标签去重）。若重复执行，
  // window.PickupDateAlert 会被替换成一个 elPopup 仍为 null 的新实例，
  // 而 document 上的委托监听器还指向旧闭包 —— 点击按钮时 open() 静默 return，
  // 页面看起来「毫无反应」。这里让第二次及以后的执行整体变成 no-op。
  if (window.PickupDateAlert) return

  var STORAGE_KEY  = 'dd_pickup_date_alert'
  var WEEKDAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var MONTH_NAMES   = ['January', 'February', 'March', 'April', 'May', 'June',
                       'July', 'August', 'September', 'October', 'November', 'December']
  var MONTH_SHORT   = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                       'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var YEAR_SPAN     = 5

  function todayFloor() {
    var d = new Date()
    d.setHours(0, 0, 0, 0)
    return d
  }

  function fmt(date) {
    if (!date) return ''
    var y = date.getFullYear()
    var m = String(date.getMonth() + 1).padStart(2, '0')
    var day = String(date.getDate()).padStart(2, '0')
    return y + '-' + m + '-' + day
  }

  function fmtDate(date) {
    if (!date) return ''
    return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
  }

  function weekday(date) {
    if (!date) return ''
    return WEEKDAY_NAMES[date.getDay()]
  }

  function diffDays(a, b) {
    if (!a || !b) return 0
    var ms = Math.abs(new Date(b) - new Date(a))
    return Math.max(0, Math.ceil(ms / 86400000))
  }

  function nightsLabel(n) {
    if (!n) return ''
    return n + (n === 1 ? ' night' : ' nights')
  }

  // time_zone 传什么就显示什么，直接透传
  function getCityTZ(tz) {
    return tz || 'Asia/Shanghai'
  }

  function buildCalendar(year, month) {
    var firstDay = new Date(year, month, 1)
    var daysInMonth = new Date(year, month + 1, 0).getDate()
    var startWd = firstDay.getDay()
    var today = todayFloor()
    var cells = []
    var prevLast = new Date(year, month, 0).getDate()
    for (var i = startWd - 1; i >= 0; i--) {
      cells.push({ day: prevLast - i, otherMonth: true, disabled: true })
    }
    for (var d = 1; d <= daysInMonth; d++) {
      var date = new Date(year, month, d)
      date.setHours(0, 0, 0, 0)
      cells.push({ day: d, date: date, disabled: date < today, otherMonth: false })
    }
    var remain = (7 - (cells.length % 7)) % 7
    for (var dd = 1; dd <= remain; dd++) {
      cells.push({ day: dd, otherMonth: true, disabled: true })
    }
    return cells
  }

  function isInRange(date, a, b) {
    if (!a || !b) return false
    var lo = a < b ? a : b
    var hi = a < b ? b : a
    return date > lo && date < hi
  }

  function toDate(v) {
    if (!v) return null
    if (v instanceof Date) return isNaN(v.getTime()) ? null : v
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v))
    if (!m) return null
    var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    d.setHours(0, 0, 0, 0)
    return isNaN(d.getTime()) ? null : d
  }

  function defaultState() {
    var now = todayFloor()
    return {
      variantId: '',
      viewYear: now.getFullYear(),
      viewMonth: now.getMonth(),
      checkIn: null,
      checkOut: null,
      step: 'select',
      roomName: '',
      variantName: '',
      city: 'Beijing',
      pricePerNight: 0,
      currency: 'USD',
      quantity: 1,
      sessions: [],
    }
  }

  var state = defaultState()
  var elPopup = null
  var initDone = false

  function loadState() {
    var saved = {}
    try {
      var raw = localStorage.getItem(STORAGE_KEY)
      if (!raw) return saved
      saved = JSON.parse(raw) || {}
    } catch (_) { return {} }
    var out = {}
    var y = Number(saved.viewYear)
    var m = Number(saved.viewMonth)
    if (y >= 1970 && y <= 2999) out.viewYear = y
    if (m >= 0 && m <= 11) out.viewMonth = m
    var today = todayFloor()
    var ci = toDate(saved.checkIn)
    var co = toDate(saved.checkOut)
    if (ci && ci < today) { ci = null; co = null }
    if (ci && co && co <= ci) co = null
    if (ci) out.checkIn = ci
    if (co) out.checkOut = co
    return out
  }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        viewYear: state.viewYear,
        viewMonth: state.viewMonth,
        checkIn: state.checkIn ? fmt(state.checkIn) : null,
        checkOut: state.checkOut ? fmt(state.checkOut) : null,
      }))
    } catch (_) {}
  }

  var refs = {}

  function cacheRefs() {
    if (!elPopup) return
    var sel = function (id) { return elPopup.querySelector('#' + id) }
    refs = {
      grid: sel('pdaCalGrid'),
      header: sel('pdaCalHeader'),
      stepView: sel('pdaStepView'),
      confirmView: sel('pdaConfirmView'),
      checkIn: sel('pdaCheckIn'),
      checkInWd: sel('pdaCheckInWd'),
      checkOut: sel('pdaCheckOut'),
      checkOutWd: sel('pdaCheckOutWd'),
      duration: sel('pdaDuration'),
      variantName: sel('pdaVariantName'),
      cityTz: sel('pdaCityTz'),
      roomInfo: sel('pdaRoomInfo'),
      totalPrice: sel('pdaTotalPrice'),
      confirmSession: sel('pdaConfirmSession'),
      confirmTz: sel('pdaConfirmTz'),
      confirmDuration: sel('pdaConfirmDuration'),
      confirmVariant: sel('pdaConfirmVariant'),
      confirmRoom: sel('pdaConfirmRoom'),
      confirmTotal: sel('pdaConfirmTotal'),
      eyebrow: sel('pdaEyebrow'),
      title: sel('pdaTitle'),
      progress: sel('pdaProgressFill'),
      continueBtn: sel('pdaBtnContinue'),
    }
  }

  function renderCalHeader() {
    if (!refs.header) return
    refs.header.innerHTML =
      '<button type="button" class="pda-nav-btn" data-action="prev-month" aria-label="Previous month">&lsaquo;</button>' +
      '<span class="pda-cal-title" role="button" tabindex="0" aria-haspopup="dialog" aria-label="Choose month and year">' +
        MONTH_NAMES[state.viewMonth] + ' ' + state.viewYear +
      '</span>' +
      '<button type="button" class="pda-nav-btn" data-action="next-month" aria-label="Next month">&rsaquo;</button>'
    var prevBtn = refs.header.querySelector('[data-action="prev-month"]')
    var nextBtn = refs.header.querySelector('[data-action="next-month"]')
    var titleEl = refs.header.querySelector('.pda-cal-title')
    if (prevBtn) prevBtn.addEventListener('click', function () { stepMonth(-1) })
    if (nextBtn) nextBtn.addEventListener('click', function () { stepMonth(1) })
    if (titleEl) {
      titleEl.addEventListener('click', function () { showPickerPanel() })
      titleEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showPickerPanel() }
      })
    }
  }

  function stepMonth(delta) {
    state.viewMonth += delta
    if (state.viewMonth < 0) { state.viewMonth = 11; state.viewYear-- }
    if (state.viewMonth > 11) { state.viewMonth = 0; state.viewYear++ }
    saveState()
    renderAll()
  }

  var elPickerPanel = null
  var pickerYear = null

  function showPickerPanel() {
    if (elPickerPanel) { closePicker(); return }
    pickerYear = state.viewYear
    elPickerPanel = document.createElement('div')
    elPickerPanel.className = 'pda-picker-panel'
    elPickerPanel.setAttribute('role', 'dialog')
    elPickerPanel.setAttribute('aria-label', 'Choose month and year')
    document.body.appendChild(elPickerPanel)
    renderPicker()
    positionPicker()
    window.addEventListener('resize', positionPicker)
    window.addEventListener('scroll', positionPicker, true)
    setTimeout(function () { document.addEventListener('mousedown', onDocMouseDown) }, 0)
  }

  function closePicker() {
    if (!elPickerPanel) return
    elPickerPanel.remove()
    elPickerPanel = null
    pickerYear = null
    window.removeEventListener('resize', positionPicker)
    window.removeEventListener('scroll', positionPicker, true)
    document.removeEventListener('mousedown', onDocMouseDown)
  }

  function onDocMouseDown(e) {
    if (!elPickerPanel) return
    if (elPickerPanel.contains(e.target)) return
    var titleEl = refs.header && refs.header.querySelector('.pda-cal-title')
    if (titleEl && titleEl.contains(e.target)) return
    closePicker()
  }

  function positionPicker() {
    if (!elPickerPanel) return
    var titleEl = refs.header && refs.header.querySelector('.pda-cal-title')
    if (!titleEl) return
    var r = titleEl.getBoundingClientRect()
    var w = elPickerPanel.offsetWidth || 240
    var h = elPickerPanel.offsetHeight || 220
    var left = Math.min(Math.max(8, r.left + r.width / 2 - w / 2), window.innerWidth - w - 8)
    var top = r.bottom + 6
    if (top + h > window.innerHeight - 8) top = Math.max(8, r.top - h - 6)
    elPickerPanel.style.left = left + 'px'
    elPickerPanel.style.top = top + 'px'
  }

  function renderPicker() {
    if (!elPickerPanel) return
    var nowYear = new Date().getFullYear()
    var minYear = nowYear - YEAR_SPAN
    var maxYear = nowYear + YEAR_SPAN
    var atMin = pickerYear <= minYear
    var atMax = pickerYear >= maxYear
    var html =
      '<div class="pda-picker-head">' +
        '<button type="button" class="pda-picker-nav" data-step="-1" aria-label="Previous year"' +
          (atMin ? ' disabled' : '') + '>&lsaquo;</button>' +
        '<span class="pda-picker-year">' + pickerYear + '</span>' +
        '<button type="button" class="pda-picker-nav" data-step="1" aria-label="Next year"' +
          (atMax ? ' disabled' : '') + '>&rsaquo;</button>' +
      '</div>' +
      '<div class="pda-picker-list">'
    for (var i = 0; i < MONTH_SHORT.length; i++) {
      var isActive = (pickerYear === state.viewYear && i === state.viewMonth)
      html += '<button type="button" class="pda-picker-item' + (isActive ? ' is-active' : '') +
              '" data-month="' + i + '">' + MONTH_SHORT[i] + '</button>'
    }
    html += '</div>'
    elPickerPanel.innerHTML = html
    var navs = elPickerPanel.querySelectorAll('.pda-picker-nav')
    for (var n = 0; n < navs.length; n++) {
      navs[n].addEventListener('click', (function (btn) {
        return function () {
          pickerYear = Math.min(maxYear, Math.max(minYear, pickerYear + Number(btn.dataset.step)))
          renderPicker()
          positionPicker()
        }
      })(navs[n]))
    }
    var items = elPickerPanel.querySelectorAll('.pda-picker-item')
    for (var m = 0; m < items.length; m++) {
      items[m].addEventListener('click', (function (btn) {
        return function () {
          state.viewYear = pickerYear
          state.viewMonth = Number(btn.dataset.month)
          saveState()
          closePicker()
          renderAll()
        }
      })(items[m]))
    }
  }

  function renderWeekdays() {
    var container = document.getElementById('pdaWeekdays')
    if (!container) return
    var html = ''
    for (var i = 0; i < WEEKDAY_NAMES.length; i++) {
      html += '<span>' + WEEKDAY_NAMES[i] + '</span>'
    }
    container.innerHTML = html
  }

  function renderCalendar() {
    if (!refs.grid) return
    var cells = buildCalendar(state.viewYear, state.viewMonth)
    var today = todayFloor()
    var checkIn = state.checkIn
    var checkOut = state.checkOut
    refs.grid.innerHTML = ''
    for (var idx = 0; idx < cells.length; idx++) {
      var cell = cells[idx]
      var btn = document.createElement('button')
      btn.type = 'button'
      btn.className = 'pda-calendar-cell'
      btn.disabled = cell.disabled
      btn.textContent = cell.day
      btn.setAttribute('aria-label', cell.date
        ? fmt(cell.date) + ' ' + WEEKDAY_NAMES[cell.date.getDay()]
        : '')
      if (cell.otherMonth) btn.classList.add('pda-other-month')
      if (cell.date && cell.date.getTime() === today.getTime()) btn.classList.add('pda-today')
      if (cell.date) {
        var t = cell.date.getTime()
        var isCI = checkIn && t === checkIn.getTime()
        var isCO = checkOut && t === checkOut.getTime()
        var inRng = isInRange(cell.date, checkIn, checkOut)
        if (isCI || isCO) btn.classList.add('pda-selected')
        if (inRng) btn.classList.add('pda-range')
      }
      ;(function (d) {
        btn.addEventListener('click', function () { handleClickDate(d) })
      })(cell.date)
      refs.grid.appendChild(btn)
    }
  }

  function handleClickDate(date) {
    if (!date || date < todayFloor()) return
    var checkIn = state.checkIn
    var checkOut = state.checkOut
    if (!checkIn || (checkIn && checkOut)) {
      state.checkIn = date
      state.checkOut = null
    } else if (date.getTime() === checkIn.getTime()) {
      state.checkIn = null
      state.checkOut = null
    } else if (date > checkIn) {
      state.checkOut = date
    } else {
      state.checkIn = date
      state.checkOut = null
    }
    saveState()
    renderAll()
  }

  function renderSummary() {
    var checkIn = state.checkIn
    var checkOut = state.checkOut
    var nights = diffDays(checkIn, checkOut)
    if (refs.checkIn) refs.checkIn.textContent = fmtDate(checkIn)
    if (refs.checkInWd) refs.checkInWd.textContent = weekday(checkIn)
    if (refs.checkOut) refs.checkOut.textContent = fmtDate(checkOut)
    if (refs.checkOutWd) refs.checkOutWd.textContent = weekday(checkOut)
    if (refs.duration) refs.duration.textContent = nightsLabel(nights)
    if (refs.variantName) refs.variantName.textContent = state.variantName || 'Standard Room'
    if (refs.cityTz) refs.cityTz.textContent = getCityTZ(state.city)
    if (refs.roomInfo) refs.roomInfo.textContent = state.roomName || ''
    if (refs.totalPrice) {
      var total = nights * state.pricePerNight
      refs.totalPrice.textContent = total > 0 ? state.currency + ' ' + total.toLocaleString() : ''
    }
  }

  function renderConfirm() {
    var checkIn = state.checkIn
    var checkOut = state.checkOut
    var nights = diffDays(checkIn, checkOut)
    if (refs.confirmSession) {
      if (state.sessions && state.sessions.length > 0) {
        var parts = []
        for (var i = 0; i < state.sessions.length; i++) {
          var s = state.sessions[i]
          var sd = toDate(s.date)
          parts.push('<span class="pda-session-tag">' + (s.label || (sd ? fmt(sd) : '')) + '</span>')
        }
        refs.confirmSession.innerHTML = parts.join('')
      } else {
        refs.confirmSession.textContent = (checkIn && checkOut)
          ? fmt(checkIn) + ' → ' + fmt(checkOut) + ' (' + nightsLabel(nights) + ')'
          : ''
      }
    }
    if (refs.confirmRoom) refs.confirmRoom.textContent = state.roomName || ''
    if (refs.confirmTz) refs.confirmTz.textContent = getCityTZ(state.city)
    if (refs.confirmDuration) refs.confirmDuration.textContent = nightsLabel(nights)
    if (refs.confirmVariant) refs.confirmVariant.textContent = state.variantName || 'Standard Room'
    if (refs.confirmTotal) {
      var total = nights * state.pricePerNight
      refs.confirmTotal.textContent = total > 0 ? state.currency + ' ' + total.toLocaleString() : ''
    }
  }

  function goToStep(step) {
    // 进入确认步骤前必须已选好入住/退房日期，否则 nights 会是 0，
    // 到 checkout 那层被 Number(0) || 1 接住，静默按 1 晚下单
    if (step === 'confirm' && !(state.checkIn && state.checkOut)) {
      alert('Please select your check-in and check-out dates.')
      return
    }
    state.step = step
    saveState()
    closePicker()
    renderAll()
  }

  function renderSteps() {
    // 日期未选完时置灰 Continue：让用户一开始就无法点错，
    // 而不是点了之后再被 goToStep 的 alert 纠正
    if (refs.continueBtn) {
      refs.continueBtn.disabled = !(state.checkIn && state.checkOut)
    }
    if (!refs.stepView || !refs.confirmView) return
    var isSelect = state.step === 'select'
    refs.stepView.style.display = isSelect ? '' : 'none'
    refs.confirmView.style.display = isSelect ? 'none' : ''
    if (refs.eyebrow) refs.eyebrow.textContent = isSelect ? 'Step 1 of 2' : 'Step 2 of 2'
    if (refs.title) refs.title.textContent = isSelect ? 'Select your dates' : 'Review & confirm'
    if (refs.progress) refs.progress.style.width = isSelect ? '50%' : '100%'
  }

  function renderAll() {
    renderWeekdays()
    renderCalHeader()
    renderCalendar()
    renderSummary()
    renderConfirm()
    renderSteps()
  }

  var lastFocused = null

  function open(config) {
    if (!elPopup) return
    if (config) switchTo(config)
    lastFocused = document.activeElement
    elPopup.classList.add('is-open')
    document.body.style.overflow = 'hidden'
    var closeBtn = elPopup.querySelector('.pda-close')
    if (closeBtn) closeBtn.focus()
  }

  function close() {
    if (!elPopup) return
    elPopup.classList.remove('is-open')
    document.body.style.overflow = ''
    closePicker()
    if (lastFocused && lastFocused.focus) lastFocused.focus()
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') { closePicker(); close() }
  }

  function switchTo(config) {
    config = config || {}
    state.variantId = config.variantId || state.variantId
    state.roomName = config.roomName || state.roomName
    state.variantName = config.variantName || state.variantName
    state.city = config.city || state.city
    state.pricePerNight = Number(config.pricePerNight) || state.pricePerNight
    state.currency = config.currency || state.currency
    state.quantity = config.quantity || state.quantity
    renderAll()
  }

  function handleBookNow(e) {
    // 防御性阻止默认行为：若按钮被改回 submit（或未来又套进 form），
    // 原生提交会让浏览器在 fetch 回调执行前导航离开页面，导致进不了 checkout
    if (e && e.preventDefault) e.preventDefault()

    // variantId 为空时绝不能静默 return，否则用户以为按钮坏了却毫无反馈
    if (!state.variantId) {
      console.error('[PickupDateAlert] 当前房型未配置 variant_id，无法下单')
      alert('This room is not available for online booking yet. Please contact us.')
      return
    }

    // 兜底：正常流程已被 goToStep 拦住，这里防的是 setState 等旁路，
    // 避免 nights = 0 被 checkout 层的 Number(0) || 1 静默改成 1 晚
    if (!state.checkIn || !state.checkOut) {
      console.error('[PickupDateAlert] 入住/退房日期不完整，已中止下单')
      alert('Please select your check-in and check-out dates.')
      return
    }

    var nights = diffDays(state.checkIn, state.checkOut)
    var detail = {
      variantId: state.variantId || '',
      checkIn: state.checkIn ? fmt(state.checkIn) : null,
      checkOut: state.checkOut ? fmt(state.checkOut) : null,
      nights: nights,
      variantName: state.variantName,
      roomName: state.roomName,
      city: state.city,
      pricePerNight: state.pricePerNight,
      currency: state.currency,
      total: nights * state.pricePerNight,
      sessions: state.sessions,
    }
    if (typeof window.__pdOnBookNow === 'function') window.__pdOnBookNow(detail)
  }

  function bindEvents() {
    if (elPopup.dataset.pdaBound) return
    elPopup.dataset.pdaBound = '1'
    var bindClick = function (selector, handler) {
      var el = elPopup.querySelector(selector)
      if (!el) return
      el.addEventListener('click', handler)
    }
    bindClick('.pda-close', close)
    bindClick('.pda-backdrop', close)
    bindClick('#pdaBtnContinue', function () { goToStep('confirm') })
    bindClick('#pdaBtnBack', function () { goToStep('select') })
    bindClick('.pda-book-btn', handleBookNow)
    document.addEventListener('keydown', handleKeydown)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pda-variant-id]')
      if (!btn) return
      e.preventDefault()
      var variantId = String(btn.dataset.pdaVariantId)
      var configs = window.__pdaConfigs || []
      var cfg = null
      for (var i = 0; i < configs.length; i++) {
        if (String(configs[i].variantId) === variantId) { cfg = configs[i]; break }
      }
      if (!cfg || !window.PickupDateAlert) return
      window.PickupDateAlert.switchTo(cfg)
      window.PickupDateAlert.open()
    })
  }

  function buildBookNowWrap() {
    // 裸按钮，不用 <form> 包裹：提交动作由 __pdOnBookNow 回调统一处理
    return '<button type="button" class="pda-book-btn">Book Now</button>'
  }

  function buildMarkup() {
    var variantDisplay = state.variantName || 'Standard Room'
    var cityTzDisplay = state.city + ' · ' + getCityTZ(state.city)
    var roomDisplay = state.roomName || ''
    return '' +
      '<div class="pda-backdrop"></div>' +
      '<div class="pda-dialog">' +
        '<div class="pda-header">' +
          '<div class="pda-header-text">' +
            '<span class="pda-eyebrow" id="pdaEyebrow">Step 1 of 2</span>' +
            '<span class="pda-title" id="pdaTitle">Select your dates</span>' +
          '</div>' +
          '<button type="button" class="pda-close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="pda-progress"><span class="pda-progress-fill" id="pdaProgressFill"></span></div>' +
        '<div class="pda-step" id="pdaStepView">' +
          '<div class="pda-calendar-wrap">' +
            '<div class="pda-cal">' +
              '<div class="pda-cal-header" id="pdaCalHeader"></div>' +
              '<div class="pda-weekdays" id="pdaWeekdays"></div>' +
              '<div class="pda-cal-grid" id="pdaCalGrid"></div>' +
            '</div>' +
          '</div>' +
          '<aside class="pda-side">' +
            '<div class="pda-stay">' +
              '<div class="pda-stay-col">' +
                '<span class="pda-stay-label">Check-in</span>' +
                '<span class="pda-stay-value" id="pdaCheckIn"></span>' +
                '<span class="pda-stay-sub" id="pdaCheckInWd"></span>' +
              '</div>' +
              '<span class="pda-stay-arrow">&rarr;</span>' +
              '<div class="pda-stay-col">' +
                '<span class="pda-stay-label">Check-out</span>' +
                '<span class="pda-stay-value" id="pdaCheckOut"></span>' +
                '<span class="pda-stay-sub" id="pdaCheckOutWd"></span>' +
              '</div>' +
            '</div>' +
            '<dl class="pda-facts">' +
              '<div class="pda-fact"><dt>Duration</dt><dd id="pdaDuration">' + nightsLabel(0) + '</dd></div>' +
              '<div class="pda-fact"><dt>Time Zone</dt><dd id="pdaCityTz">' + cityTzDisplay + '</dd></div>' +
              '<div class="pda-fact"><dt>Variant</dt><dd id="pdaVariantName">' + variantDisplay + '</dd></div>' +
              '<div class="pda-fact"><dt>Hotel</dt><dd id="pdaRoomInfo">' + roomDisplay + '</dd></div>' +
            '</dl>' +
            '<div class="pda-total">' +
              '<span class="pda-total-label">Total</span>' +
              '<span class="pda-total-value" id="pdaTotalPrice"></span>' +
            '</div>' +
            '<button type="button" class="pda-continue-btn" id="pdaBtnContinue" disabled>Continue</button>' +
          '</aside>' +
        '</div>' +
        '<div class="pda-confirm-step" id="pdaConfirmView" style="display:none">' +
          '<div class="pda-confirm-head">' +
            '<span class="pda-confirm-kicker">Booking summary</span>' +
            '<h3 class="pda-confirm-room" id="pdaConfirmRoom">' + roomDisplay + '</h3>' +
          '</div>' +
          '<div class="pda-receipt">' +
            '<div class="pda-receipt-row"><span class="pda-receipt-label">Session date</span><span class="pda-receipt-value" id="pdaConfirmSession"></span></div>' +
            '<div class="pda-receipt-row"><span class="pda-receipt-label">Time zone</span><span class="pda-receipt-value" id="pdaConfirmTz">' + getCityTZ(state.city) + '</span></div>' +
            '<div class="pda-receipt-row"><span class="pda-receipt-label">Duration</span><span class="pda-receipt-value" id="pdaConfirmDuration"></span></div>' +
            '<div class="pda-receipt-row"><span class="pda-receipt-label">Variant</span><span class="pda-receipt-value" id="pdaConfirmVariant">' + variantDisplay + '</span></div>' +
            '<div class="pda-receipt-row pda-receipt-total"><span class="pda-receipt-label">Total</span><span class="pda-receipt-value" id="pdaConfirmTotal"></span></div>' +
          '</div>' +
          '<div class="pda-confirm-actions">' +
            buildBookNowWrap() +
            '<button type="button" class="pda-back-btn" id="pdaBtnBack">&#8592; Back to dates</button>' +
          '</div>' +
        '</div>' +
      '</div>'
  }

  function init(config) {
    if (initDone) return
    initDone = true
    config = config || {}
    state = Object.assign({}, defaultState(), loadState(), config)
    state.checkIn = toDate(state.checkIn)
    state.checkOut = toDate(state.checkOut)
    state.pricePerNight = Number(state.pricePerNight) || 0
    var existingPopup = document.getElementById('ddPickupDateAlert')
    if (existingPopup) {
      elPopup = existingPopup
    } else {
      elPopup = document.createElement('div')
      elPopup.id = 'ddPickupDateAlert'
      elPopup.className = 'pda-popup'
      elPopup.setAttribute('role', 'dialog')
      elPopup.setAttribute('aria-modal', 'true')
      elPopup.setAttribute('aria-label', 'Select check-in and check-out dates')
      elPopup.innerHTML = buildMarkup()
      document.body.appendChild(elPopup)
    }
    cacheRefs()
    bindEvents()
    renderAll()
  }

  // ─── 自动初始化：检测 Liquid 注入的 window.__pdaInitConfig ──────────────────
  // 必须在 window.PickupDateAlert 赋值之后执行

  window.PickupDateAlert = {
    init: init,
    open: open,
    close: close,
    switchTo: switchTo,
    getState: function () { return Object.assign({}, state) },
    setState: function (patch) {
      state = Object.assign(state, patch)
      state.checkIn = toDate(state.checkIn)
      state.checkOut = toDate(state.checkOut)
      state.pricePerNight = Number(state.pricePerNight) || 0
      saveState()
      if (elPopup) renderAll()
    },
  }

  if (window.__pdaInitConfig) {
    ;(function () {
      function run() {
        if (typeof window.PickupDateAlert === 'undefined') return
        window.PickupDateAlert.init(window.__pdaInitConfig)
        delete window.__pdaInitConfig
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run)
      } else {
        run()
      }
    })()
  }
})()
